var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zmbddgkeaa",
    d: "M0 0.001L20 0.001 20 20 0 20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -244) translate(85 139) translate(33 105.5) translate(0 -.001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uy5joij5zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zmbddgkeaa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M18.724.001H1.278C.573.001 0 .572 0 1.277v17.448C0 19.427.572 20 1.278 20h17.446c.705 0 1.276-.573 1.276-1.275V1.277c0-.705-.571-1.276-1.276-1.276m0 1c.152 0 .276.124.276.276v17.448c0 .151-.124.275-.276.275H1.278C1.125 19 1 18.876 1 18.725V1.277c0-.152.125-.276.278-.276h17.446",
    mask: "url(#uy5joij5zb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M10.956 12.61L10.956 10.361 8.764 10.361 8.764 12.61 7.735 12.61 7.735 7.429 8.764 7.429 8.764 9.494 10.956 9.494 10.956 7.429 11.976 7.429 11.976 12.61zM14.244 9.937c.107.024.31.034.503.034.704 0 1.14-.373 1.14-.973 0-.545-.4-.885-1.044-.885-.23 0-.346.02-.554.059l-.045.014v1.75zm-1.011 2.673V7.482l.213-.025c.375-.046.824-.068 1.333-.068.719 0 1.236.134 1.582.409.342.27.539.697.539 1.169 0 .494-.166.922-.466 1.206-.373.353-.954.539-1.68.539-.153 0-.292-.007-.402-.023l-.108-.015v1.936h-1.011zM4.112 9.937c.106.024.309.034.502.034.704 0 1.141-.373 1.141-.973 0-.545-.4-.885-1.044-.885-.229 0-.337.018-.554.059l-.045.014v1.75zM3.1 12.61V7.482l.212-.025c.376-.046.825-.068 1.335-.068.719 0 1.237.134 1.582.409.342.27.539.697.539 1.169 0 .493-.166.92-.466 1.206-.375.353-.956.539-1.68.539-.154 0-.293-.007-.402-.023l-.108-.015v1.936H3.1z",
    transform: "translate(-118 -244) translate(85 139) translate(33 105.5)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo8);
export default __webpack_public_path__ + "static/media/gamelogo8.676817f9f6da331316d988e73e566332.svg";
export { ForwardRef as ReactComponent };